module.exports = __webpack_public_path__ + "img/sbp_1.7854f169.svg";